import React, { useState } from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import ToolPageLayout from '../../components/ToolPageLayout';
import { useLanguage } from '../../contexts/LanguageContext';

const parseDate = (str) => {
  if (!str) return null;
  const [y, m, d] = str.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};

const addDays = (date, days) => {
  const d = new Date(date);
  d.setUTCDate(d.getUTCDate() + days);
  return d;
};

const formatDate = (date, isRTL) =>
  date.toLocaleDateString(isRTL ? 'ar-DZ-u-nu-latn' : 'fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });

const OvulationCalculator = () => {
  const { t, isRTL } = useLanguage();
  const [lastPeriod, setLastPeriod] = useState('');
  const [cycleLength, setCycleLength] = useState('28');

  const lmp = parseDate(lastPeriod);
  const cycle = parseInt(cycleLength, 10) || 28;
  const ovulation = lmp ? addDays(lmp, cycle - 14) : null;
  const fertileStart = ovulation ? addDays(ovulation, -5) : null;
  const fertileEnd = ovulation ? addDays(ovulation, 1) : null;
  const nextPeriod = lmp ? addDays(lmp, cycle) : null;

  return (
    <ToolPageLayout
      title={t('ovulation_title')}
      subtitle={t('ovulation_subtitle')}
      specialty="gynecologue"
    >
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <Label className="mb-1 block">{t('ovulation_lmp_label')}</Label>
          <Input
            type="date"
            value={lastPeriod}
            onChange={(e) => setLastPeriod(e.target.value)}
            className="rounded-xl"
          />
        </div>
        <div>
          <Label className="mb-1 block">{t('ovulation_cycle_label')}</Label>
          <Input
            type="number"
            min="20"
            max="45"
            value={cycleLength}
            onChange={(e) => setCycleLength(e.target.value)}
            className="rounded-xl"
          />
        </div>
      </div>

      {ovulation && (
        <div className="mt-8 space-y-4">
          <div className="bg-[#F8FAFC] rounded-2xl p-6 border border-[#E2E8F0]">
            <div className="text-sm text-[#64748B] mb-1">{t('ovulation_result_label')}</div>
            <div className="text-xl font-bold text-[#0F172A] capitalize">{formatDate(ovulation, isRTL)}</div>
          </div>
          <div className="bg-[#E6F4FB] rounded-2xl p-6 border border-[#0596DE]/20">
            <div className="text-sm text-[#64748B] mb-1">{t('ovulation_fertile_label')}</div>
            <div className="text-lg font-semibold text-[#0F172A] capitalize">
              {t('ovulation_from')} {formatDate(fertileStart, isRTL)}<br />{t('ovulation_to')} {formatDate(fertileEnd, isRTL)}
            </div>
          </div>
          <div className="bg-[#F8FAFC] rounded-2xl p-6 border border-[#E2E8F0]">
            <div className="text-sm text-[#64748B] mb-1">{t('ovulation_next_period_label')}</div>
            <div className="text-lg font-semibold text-[#0F172A] capitalize">{formatDate(nextPeriod, isRTL)}</div>
          </div>
        </div>
      )}

      <p className="mt-6 text-sm text-[#64748B]">
        {t('ovulation_disclaimer')}
      </p>
    </ToolPageLayout>
  );
};

export default OvulationCalculator;
